import { useCallback } from "react";

import { useMutation, graphql, useFragment } from "react-relay";
import { TodoPriority } from "../TodoTimeline/__generated__/TodoTimelineUpdateEventIcon_event.graphql";

import { useTodoEditSetPrioMutation } from "./__generated__/useTodoEditSetPrioMutation.graphql";

import { useTodoEditSetPrio_todo$key } from "./__generated__/useTodoEditSetPrio_todo.graphql";

export function useTodoEditSetPrio(
  todoKey: useTodoEditSetPrio_todo$key,
  currentEmployeeId: string | null
) {
  const todo = useFragment(
    graphql`
      fragment useTodoEditSetPrio_todo on Todo {
        id
        priority
        ordinal
      }
    `,
    todoKey
  );
  const [updateTags, loading] = useMutation<useTodoEditSetPrioMutation>(graphql`
    mutation useTodoEditSetPrioMutation(
      $id: ID!
      $prio: TodoPriority!
      $employeeId: ID
    ) {
      todo(todoId: $id, employeeId: $employeeId) {
        updatePriority(input: { priority: $prio }) {
          todo {
            id
            priority
            ordinal
            ...TodoEditTimeline_todo @defer
          }
        }
      }
    }
  `);

  const savePrio = useCallback(
    (prio: TodoPriority) => {
      return updateTags({
        variables: {
          id: todo.id,
          prio,
          employeeId: currentEmployeeId,
        },
        optimisticUpdater: (store) => {
          store.get(todo.id)?.setValue(prio, "priority");
        },
      });
    },
    [todo.id, updateTags, currentEmployeeId]
  );

  return [savePrio, loading] as const;
}
